"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
function useMobile() {
    var _a, _b, _c;
    // 750 width prevents overlap of layout switch and button bar on guest client
    // Less the width of the side-bar of 51px
    var isMobileWidth = core_1.useMediaQuery('(max-width:699px)');
    var isMobileHeight = core_1.useMediaQuery('(max-height:600px)');
    var isMobile = isMobileHeight || isMobileWidth;
    var isPortrait = core_1.useMediaQuery('(orientation: portrait)');
    var isIOS = /iPad|iPhone|iPod/.test((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.platform) ||
        (((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.platform) === 'MacIntel' && ((_c = window.navigator) === null || _c === void 0 ? void 0 : _c.maxTouchPoints) > 1);
    return {
        isIOS: isIOS,
        isMobile: isMobile,
        isMobileHeight: isMobileHeight,
        isMobileWidth: isMobileWidth,
        isPortrait: isPortrait
    };
}
exports.default = useMobile;
